<nb-card status="primary" class="cart-table">
  <div class="columns">
    <div class="column">
      <div class="all-table">
        <grid-gear [list]="this"/>

        <ngx-table [configuration]="configuration"
                   [pagination]="pagination"
                   [data]="productList"
                   (event)="eventEmitted($event)"
                   #table
                   [columns]="columns">
        </ngx-table>
      </div>
    </div>
  </div>
  <ng-template #codeIconTpl let-row data-th="Артикул">
    <div class="responsive-table product-list__table-code" data-th="Артикул">
      <div class="code-table">
        <div class="code-table__title">
          <p><span class="mouse-pointer" (click)="openModalProduct(row)" ><app-search-code-highlight [code]="row.productCode" [query]="searchKeyword"/></span></p>
        </div>
        <app-code-icons [row]="row"/>
      </div>
    </div>
  </ng-template>

  <ng-template #photoTpl let-row data-th="Фото">
    <div class="responsive-table product-list__photo" data-th="Фото">
      <div class="photo-table">
        <div class="photo-table__picture">
          <a class="mouse-pointer" (click)="openModalProduct(row)">
            <img *ngIf="row.picture; else noPhotoTpl" fill [ngSrc]="getImageUri(row.picture)" alt="">
            <ng-template #noPhotoTpl><img [src]="noPhotoSrc" alt="" style="position:absolute;width:100%;height:100%;object-fit:contain;"></ng-template>
          </a>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #headerTpl let-row>
    <div class="responsive-table" i18n-data-th="@@CodeName" data-th="Наименование">
      <div class="name-table">
        <div class="name-table__title">
          <p><span class="mouse-pointer" (click)="openModalProduct(row)"><app-search-code-highlight field="name" [code]="row.header" [productCode]="row.productCode" [query]="searchKeyword"/></span></p>
        </div>

        <div class="name-table__icons" *ngIf="row?.markers">
          <ng-container *ngFor="let marker of row.markers">
            <div class="item" *ngIf="11 !== marker.id">
              <div style="line-height: normal; padding:2px 0">{{marker.header}}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deliveryAtpTpl let-row>
    <div class="responsive-table">
      <div>
        {{row.deliveryAtp | date: "dd.MM.yyyy"}}
      </div>
    </div>
  </ng-template>

  <ng-template #availabilityTpl let-row>
    <app-product-availability [product]="row"/>
  </ng-template>

  <ng-template #wmsTpl let-row let-column="column">
    <app-product-wms [product]="row" [column]="column"/>
  </ng-template>

  <ng-template #priceTpl let-row>
    <app-product-price [product]="row" [hideCurrency]="true"/>
  </ng-template>

  <ng-template #priceNdsTpl let-row>
      <app-product-price [product]="row" [hideCurrency]="true" [showVAT]="true" />
  </ng-template>

  <ng-template #cartTpl let-row let-rowIndex="rowIndex">
    @if (customCartTpl) {
      <ng-container *ngTemplateOutlet="customCartTpl; context: {row:row, rowIndex:rowIndex}"/>
    }

    @if (!customCartTpl && isShowRequestedProducts(row)) {
      <button class="attach-btn" nbButton status="primary" size="small" (click)="openAddToRequestedProducts(row)">
        <nb-icon icon="attach-outline"/>
      </button>
    } @else {
      <app-add-to-cart [product]="row" [catalog]="true"></app-add-to-cart>
    }
  </ng-template>

  <ng-content select="[cartTpl]"></ng-content>
</nb-card>
